import { __callbacks } from "Utils/Callbacks/Callback";
import { useCallback, useEffect, useRef, useState } from "react";
import styles from "./InputEmail.module.scss";


export default function InputEmail(props) {

  const input = useRef(null);
  const [classLabelTransform, setClassLabelTransform] = useState("")
  const [classError, setClassError] = useState("");
  const [isValid, setIsValid] = useState(false);
  const validateEmail = useCallback(
    (emailAdress) => {
      let regexEmail = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/;
      if (emailAdress.match(regexEmail)) {
        return true;
      } else {
        return false;
      }
    },
    [],
  );
  const onInput = useCallback(
    () => {
      if (input.current.value === "") {
        setClassLabelTransform(styles[""]);
      }
      else {
        setClassLabelTransform(styles["label-transform"]);
      }

      if (validateEmail(input.current.value)) {
        setClassError("");
        setIsValid(true);
      }
      else {
        setClassError(styles["input-invalid"]);
        setIsValid(false);
      }

      //setIsValid(true);
    },
    [validateEmail],
  );


  useEffect(() => {
    input.current.addEventListener('input', e => {
      onInput()
    });
  }, [onInput]);

  const onChange = useCallback(
    () => {
      __callbacks.inputEmail.trigger({
        isValid,
        value: input.current.value
      });
    },
    [isValid],
  );

  useEffect(() => {
    onChange();
  }, [isValid, onChange]);

  useEffect(() => {
    if (!props.value) return;
    setClassLabelTransform(styles["label-transform"]);
    input.current.value = props.value;
    onInput();
  }, [props.value, onInput]);



  return (
    <div className={styles.container}>
      <input onChange={onChange} ref={input} type={props.type} className={`${styles["input-text"]} ${classError}`} required />
      <span className={`${styles["floating-label"]} ${classLabelTransform}`}>{props.title}</span>
    </div>
  )
}
